import React, {useState} from "react";
import {GenericModal} from "../generic-modal/GenericModal";
import {Box, Button} from "@mui/material";
import {GraphQlEditor} from "./GraphQlEditor";

interface IGraphQlEditorButtonProps {
	query: string;
	setQuery: (query: string) => void;
	anvaSyncStage?: string;
	anvaSyncAccount?: string;
}

export const GraphQlEditorButton: React.FC<IGraphQlEditorButtonProps> = (props) => {
	const [editGraphQl, setEditGraphQl] = useState(false);
	
	return (
		<>
			<Box sx={{marginTop: 1, marginBottom: 1}}>
				<Button
					variant="outlined"
					onClick={() => setEditGraphQl(true)}
				>
					Edit GraphQl
				</Button>
			</Box>
			<GenericModal
				open={editGraphQl}
				onClose={() => setEditGraphQl(false)}
				title={"GraphQl Query"}
			>
				<GraphQlEditor {...props} />
			</GenericModal>
		</>
	);
};
